import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  signal,
} from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-embed-modal',
  standalone: false,
  templateUrl: './embed-modal.component.html',
  styleUrl: './embed-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmbedModalComponent implements OnChanges {
  @Input() url: SafeResourceUrl | null = null;
  @Input() title = 'Document';
  @Output() closed = new EventEmitter<void>();

  readonly loaded = signal(false);
  readonly closing = signal(false);

  private readonly CLOSE_MS = 200;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url']) {
      this.loaded.set(false);
      this.closing.set(false);
    }
  }

  onFrameLoad(): void {
    this.loaded.set(true);
  }

  close(): void {
    this.closing.set(true);
    setTimeout(() => {
      this.closing.set(false);
      this.closed.emit();
    }, this.CLOSE_MS);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.url) this.close();
  }
}
